import React from 'react';
import { Card as AntCard } from 'antd';
import cn from 'classnames';

function Card({ className, tabList, extra, children, ...rest }) {
  return (
    <AntCard
      className={cn('card', className)}
      tabList={tabList}
      tabBarExtraContent={extra}
      {...rest}
    >
      {children}
    </AntCard>
  );
}

export default Card;
